import _forIn from "lodash/forIn";

export default (objs) => {
  let params = "";

  _forIn(objs, (key, value) => {
    if (!params.length) {
      params += `?${value}=${key}`;
    } else {
      params += `&${value}=${key}`;
    }
  });

  return encodeURI(params);
};



// WEBPACK FOOTER //
// ./src/services/utils/objToUrlParam.js